import type { SxProps } from '@mui/material';
import { type BadgeProps, Chip, type ChipProps } from '@side/pantry';
import { EnvelopeStatus } from '../../views/SentEvelopesSection/enums';

export const DEFAULT_CHIP_PROPS: Pick<ChipProps, 'color' | 'label'> & {
  badgeColor?: BadgeProps['color'];
  badgeFill?: BadgeProps['fill'];
} = {
  color: 'default',
  label: '',
};

export const ENVELOPE_STATUS_TO_CHIP_PROPS: Record<
  EnvelopeStatus,
  typeof DEFAULT_CHIP_PROPS
> = {
  [EnvelopeStatus.sending]: {
    color: 'default',
    label: 'Processing',
  },
  [EnvelopeStatus.partiallySigned]: {
    color: 'warning',
    label: 'Partially Signed',
    badgeColor: 'warning',
    badgeFill: 'default',
  },
  [EnvelopeStatus.notFinalized]: {
    color: 'warning',
    label: 'Finalizing',
  },
  [EnvelopeStatus.completed]: {
    color: 'success',
    label: 'Signed',
  },
  [EnvelopeStatus.voided]: {
    color: 'default',
    label: 'Voided',
  },
  [EnvelopeStatus.declined]: {
    color: 'error',
    label: 'Declined',
  },
  [EnvelopeStatus.sent]: {
    color: 'default',
    label: 'Not Signed',
    badgeColor: 'default',
    badgeFill: 'default',
  },
  [EnvelopeStatus.created]: {
    color: 'default',
    label: 'Not Signed',
    badgeColor: 'default',
    badgeFill: 'default',
  },
};

export const SignedStatus = ({
  chipProps,
  sx,
  status,
}: {
  chipProps?: Partial<ChipProps>;
  status: EnvelopeStatus | string;
  sx?: SxProps;
}) => {
  const { color, label } =
    ENVELOPE_STATUS_TO_CHIP_PROPS[status as EnvelopeStatus] ??
    DEFAULT_CHIP_PROPS;

  return (
    <Chip
      sx={{
        maxWidth: 'min-content',
        marginRight: 2,
        ...sx,
      }}
      color={color}
      label={label}
      variant="outlined"
      {...chipProps}
    />
  );
};
